export default {
    install() {

    }
}